var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('the-header'),_c('hero'),_c('showcase'),_c('in-trend'),_c('the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }